module.exports = __webpack_public_path__ + "static/media/x-img.c7138066.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/x-img.svg
// module id = 530
// module chunks = 0